export const playlist = {
  'Public playlist': 'Öffentliche Wiedergabeliste',
  songs: 'Lieder',
  Name: 'Name',
  Skills: 'Fähigkeiten',
  Filter: 'Filter',
};
